import React, { useEffect } from 'react';

const Qr = () => {
  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
      window.location.href = "https://play.google.com/store/apps/details?id=com.cashover.merchant";
    } else if (/iPad|iPhone|iPod|Macintosh/.test(userAgent) && !window.MSStream) {
      window.location.href = "https://apps.apple.com/us/app/cashover-merchant-pos-more/id6752302094";
    }
  }, []);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      fontFamily: 'system-ui, -apple-system, sans-serif',
      textAlign: 'center',
      padding: '20px',
      backgroundColor: '#f8f9fa'
    }}>
      <h2 style={{ marginBottom: '16px', color: '#333' }}>Redirecting...</h2>
      <p style={{ color: '#666', marginBottom: '24px' }}>If you are not redirected automatically, please choose your platform:</p>
      <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', justifyContent: 'center' }}>
        <a 
          href="https://play.google.com/store/apps/details?id=com.cashover.merchant"
          style={{
            padding: '12px 24px',
            backgroundColor: '#000',
            color: '#fff',
            borderRadius: '8px',
            textDecoration: 'none',
            fontWeight: '500'
          }}
        >
          Android
        </a>
        <a 
          href="https://apps.apple.com/us/app/cashover-merchant-pos-more/id6752302094"
          style={{
            padding: '12px 24px',
            backgroundColor: '#007aff',
            color: '#fff',
            borderRadius: '8px',
            textDecoration: 'none',
            fontWeight: '500'
          }}
        >
          iOS
        </a>
      </div>
    </div>
  );
};

export default Qr;
